import { render, staticRenderFns } from "./Gaopin.vue?vue&type=template&id=d0972128&scoped=true"
import script from "./Gaopin.vue?vue&type=script&lang=js"
export * from "./Gaopin.vue?vue&type=script&lang=js"
import style0 from "./Gaopin.vue?vue&type=style&index=0&id=d0972128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0972128",
  null
  
)

export default component.exports